export const environment = {
    production: true,
    runServiceWorker: false,
    restApi: {
      msB2C: "https://apiqa.argosone.com/sbox/adm/b2c/",
    },
    urlsGraphQL: {
      urlGraphQLAccounts: 'https://apiqa.argosone.com/sbox/adm/accounts/',
      urlGraphQLGeneral: "https://apiqa.argosone.com/sbox/adm/general/",
      content: "https://apiqa.argosone.com/sbox/adm/content/",
      back_office: 'https://apiqa.argosone.com/sbox/col/sto/back-office/'
    },
    backgroundImage:"https://stargosone2gsboxcol.argosone.com/argosone2g/bannersStore/loginBanner.png",
    DefaultRedirect:"https://colombiasbox.argosone.com/",
    EncryptKey :"1203199320052021",
    recaptchaSiteKey:"6LfW3PYqAAAAACXNw-WlNM5VAq36Eo1PhOB22d1Q",
    tenantId :"SBOX",
    storeId:"968E2DCB-864B-4CE2-94A7-5B713F23401E",
    x_token: 'cc330a4499e2448cb43190d5ee066aab',
    storeIdComplete:"968E2DCB-864B-4CE2-94A7-5B713F23401E",
    country:""
  };

